import { useRouter } from 'next/router'
import React from 'react'

import Button from '@components/atoms/Button'
import { ButtonModifier, ButtonTypes } from '@components/atoms/Button'
import Col from '@components/atoms/Grid/Col'
import Row from '@components/atoms/Grid/Row'
import Message from '@components/atoms/Message'
import { MessageTypes } from '@components/atoms/Message'

import { ErrorCode } from '@helper/errors'
import { PropsWithClassName } from '@helper/PropsWithClassName'
import { cn } from '@helper/utils/cn'

import {
  RoutesSunpointDefault,
  RoutesWellmaxxDefault,
} from '@definitions/routes/Routes'

import { ErrorFallbackProps } from './ErrorBoundary'

interface Props extends PropsWithClassName, ErrorFallbackProps {}

const ErrorFallback: React.FC<Props> = ({
  error,
  onRetry,
  className,
}: Props): React.JSX.Element => {
  const router = useRouter()
  const isNotFound = error.code === ErrorCode.NOT_FOUND

  const handleGoHome = (): void => {
    const theme = router.pathname.startsWith('/wellmaxx')
      ? 'wellmaxx'
      : 'sunpoint'
    const homePath =
      theme === 'wellmaxx'
        ? RoutesWellmaxxDefault.INDEX
        : RoutesSunpointDefault.INDEX
    router.push(homePath)
  }

  return (
    <div
      className={cn(
        'flex-1 flex items-center justify-center py-8 px-4',
        className
      )}
      data-testid="error-fallback-root"
    >
      <Row>
        <Col xs={12} sm={12} md={10} mdOffset={1} lg={8} lgOffset={2}>
          <Message
            type={MessageTypes.ERROR}
            headline={
              isNotFound ? 'Seite nicht gefunden' : 'Ein Fehler ist aufgetreten'
            }
          >
            <p>{error.userMessage}</p>
            <div className="mt-6! flex gap-4">
              {!isNotFound && (
                <Button
                  modifier={ButtonModifier.PRIMARY}
                  buttonType={ButtonTypes.BUTTON}
                  disabled={false}
                  loading={false}
                  onClick={onRetry}
                >
                  Erneut versuchen
                </Button>
              )}
              <Button
                modifier={ButtonModifier.SECONDARY}
                buttonType={ButtonTypes.BUTTON}
                disabled={false}
                loading={false}
                onClick={handleGoHome}
              >
                Zur Startseite
              </Button>
            </div>
          </Message>
        </Col>
      </Row>
    </div>
  )
}

export default ErrorFallback
